import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { WorkdayUserProvisioningService } from "./workday-user-provisioning-service";
import { SetupStep } from "./models";
import { StateService } from "@uirouter/angularjs";
import { hasCurrentUserRole } from "@gtmhub/users";
import { IScope } from "angular";

export class WorkdayConfigurationCtrl {
  progressSteps = SetupStep;
  indicators: {
    loading: boolean;
  };
  isAdmin: boolean;
  currentSetupStep: SetupStep;

  static $inject = ["$scope", "$state", "WorkdayUserProvisioningService", "UIErrorHandlingService"];

  constructor(
    private $scope: IScope,
    private $state: StateService,
    private workdayUserProvisioningService: WorkdayUserProvisioningService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.indicators = {
      loading: true,
    };

    this.isAdmin = hasCurrentUserRole("admin");
    this.getCurrentSetupStep();
    this.$scope.$on("progressStepChanged", this.updateCurrentSetupStep);
  }

  private getCurrentSetupStep(): void {
    this.indicators.loading = true;
    this.workdayUserProvisioningService
      .getCurrentSetupProgressStep()
      .then((response) => {
        this.currentSetupStep = response;
        this.indicators.loading = false;

        if (this.currentSetupStep >= this.progressSteps.SELECTION) {
          this.$state.go("gtmhub.configuration.workday.settings");
        }
      })
      .catch((error) => {
        // If workday settings do not exist they are created and step is calculated again
        this.indicators.loading = false;
        if (error.status === 404 && error.workdaySettingsDoesNotExists) {
          this.workdayUserProvisioningService
            .putWorkdayUserProvisionSettings({
              provisioningEnabled: false,
              sendInvitationEmail: false,
              syncSettings: {
                organizationIds: [],
                locations: [],
              },
              dataSourceSettings: {
                connectorId: null,
                dataSourceIds: [],
              },
            })
            .then(() => {
              this.updateCurrentSetupStep();
            });
        } else {
          this.uiErrorHandlingService.handleModal(error);
        }
      });
  }

  private updateCurrentSetupStep = (): void => {
    this.workdayUserProvisioningService
      .getCurrentSetupProgressStep()
      .then((response) => {
        this.currentSetupStep = response;
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
      });
  };
}
